import React from 'react';

export const AppSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 pb-24 md:pb-0 animate-pulse flex flex-col items-center">
      
      {/* 1. Header Mimic */}
      <div className="w-full bg-white h-16 border-b border-gray-100 flex items-center px-4 justify-between sticky top-0 z-50">
         <div className="h-6 w-24 bg-slate-200 rounded-lg"></div>
         <div className="h-9 w-9 bg-slate-200 rounded-full"></div>
      </div>

      {/* 2. Feed Content Mimic */}
      <div className="w-full max-w-2xl px-4 mt-6 space-y-6">
         
         {/* Daily Spark Box */}
         <div className="h-32 bg-indigo-50 rounded-3xl w-full border border-indigo-100"></div>

         {/* Post Input Box */}
         <div className="h-20 bg-white rounded-3xl w-full border border-gray-100"></div>

         {/* Fake Posts (3 items) */}
         {[1, 2, 3].map((i) => (
            <div key={i} className="bg-white rounded-[2rem] p-5 border border-gray-100 space-y-4">
                {/* Header */}
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-slate-200 rounded-full"></div>
                    <div className="space-y-2">
                        <div className="h-3 w-24 bg-slate-200 rounded"></div>
                        <div className="h-2 w-16 bg-slate-100 rounded"></div>
                    </div>
                </div>
                {/* Body Text lines */}
                <div className="space-y-2">
                    <div className="h-2 w-full bg-slate-100 rounded"></div>
                    <div className="h-2 w-3/4 bg-slate-100 rounded"></div>
                </div>
                {/* Big Image placeholder */}
                <div className="h-48 w-full bg-slate-100 rounded-2xl"></div>
            </div>
         ))}
      </div>
    </div>
  );
};